export function unpackNodeDragSource(e) {
    let sourceKind, sourceValue, sourceOptions = {};

    let source = e.dataTransfer.getData("text/plain");

    if (e.dataTransfer.types.includes("node-constructor")) {
        sourceKind = "constructor";

        if (e.type == "drop") sourceValue = e.dataTransfer.getData("node-constructor");
    } else if (e.dataTransfer.types.includes("node-row")) {
        sourceKind = "row";

        if (e.type == "drop") sourceValue = parseInt(e.dataTransfer.getData("node-row"));
    } else if (e.dataTransfer.types.includes("fragment")) {
        sourceKind = "constructor";

        if (e.type == "drop") {
            sourceValue = "Fragment";
            sourceOptions.geofence = parseInt(e.dataTransfer.getData("fragment"));
        }
    }

    return [sourceKind, sourceValue, sourceOptions];
}
